module.exports = __webpack_public_path__ + "img/clouds-rest-1.6c4fe471.jpg";